import { Skeleton, cn } from "ui";
import { SkeletonToolbar } from "../primitives/SkeletonToolbar";

type TableSkeletonProps = {
  columns?: number;
  rows?: number;
  /** Render the search / filters / date-picker toolbar above the table. */
  withToolbar?: boolean;
  className?: string;
};

export const TableSkeleton = ({
  columns = 6,
  rows = 8,
  withToolbar = true,
  className,
}: TableSkeletonProps) => (
  <div className={cn("flex flex-col gap-4", className)}>
    {withToolbar && <SkeletonToolbar withDatePicker />}

    <div className="flex flex-row sm:rounded-lg">
      <div className="w-full">
        <div className="min-w-full overflow-x-auto border border-foundations-subtle sm:rounded-lg">
          <table className="min-w-full">
            <thead className="border-b border-foundations-subtle">
              <tr>
                {Array.from({ length: columns }).map((_, i) => (
                  <th key={i} className="py-2.5 pl-6 pr-4 text-left">
                    <div className="flex h-4 items-center">
                      <Skeleton className="h-3 w-20" />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr
                  key={rowIndex}
                  className="border-b border-foundations-subtle"
                >
                  {Array.from({ length: columns }).map((_, colIndex) => (
                    <td key={colIndex} className="px-6 py-4">
                      <div className="flex h-5 items-center">
                        <Skeleton
                          className={cn(
                            "h-4",
                            colIndex === 0 ? "w-3/4" : "w-1/2"
                          )}
                        />
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);
